import { getIsolationScope as r, getCurrentScope as n } from "./chunk813.js";
import { parseEventHintOrCaptureContext as o } from "./chunk881.js";
function i(t, e) {
  return n().captureException(t, o(e));
}
function u() {
  return r().lastEventId();
}
export {
  i as captureException,
  u as lastEventId
};
